<template>
  <div class="addFile">
    <div class="addApply">
      <div class="title">
        <strong>{{title}}</strong>
      </div>
      <div class="formContent">
        <mt-field label="患者姓名" placeholder="此项为必填项" v-model="ruleForm.name" @blur.native.capture="checkInputName"></mt-field>
        <mt-field label="年龄" placeholder="此项为必填项" type="number" v-model="ruleForm.age" @blur.native.capture="checkInputAge"></mt-field>
        <div class="radioGroup">
          <span>性别</span>
          <div class="radio-inline">
            <input v-model="ruleForm.sex" id="man" type="radio" name="sex" value="1" checked/>
            <label for="man">男</label>
          </div>
          <div class="radio-inline">
            <input v-model="ruleForm.sex" id="woman" type="radio" name="sex" value="0" />
            <label for="woman">女</label>
          </div>
        </div>
        <div class="text-area" style="padding-bottom:15px;">
          <label for="bq">患者病情/初步判断</label>
          <textarea id="bq" cols="35" rows="5" placeholder="此项为必填项" v-model="ruleForm.firstDiagnosis" @blur="checkInputDiagnosis"></textarea>
        </div>
        <div class="text-area" style="padding-bottom:15px;">
          <label for="bq">病情简介/会诊原因</label>
          <textarea placeholder="此项为必填项" id="bq" cols="35" rows="5" v-model="ruleForm.illnessRemark" @blur="checkInputRemark"></textarea>
        </div>
        <!-- <mt-radio title="性别" :options="['男', '女']" v-model="ruleForm.sex"></mt-radio> -->
        <!-- <mt-field label="患者病情/初步判断" placeholder="请输入" type="textarea" rows="3" v-model="ruleForm.firstDiagnosis"></mt-field> -->
        <!-- <mt-field label="病情简介/会诊原因" placeholder="请输入" type="textarea" rows="3" v-model="ruleForm.illnessRemark"></mt-field> -->

        <div class="select-wrapper">
          <p style="padding-bottom:15px;">
            <label for="hzHospital">会诊医院:</label>
            <select name="" id="hzHospital" class="hzHospital" placeholder="请输入" v-model="ruleForm.diagnosisHospital" @change="changeHospital(ruleForm.diagnosisHospital)">
              <option value="" disabled selected hidden>请输入</option>
              <option :value="item.id" v-for="(item, index) in applyHospitalList" :key="index">{{item.hospitalName}}</option>
            </select>
          </p>
          <p>
            <label for="hzHospital">会诊医生:</label>
            <select name="" id="hzHospital" class="hzHospital" placeholder="请输入" v-model="ruleForm.diagnosisDoctor">
              <option value="" disabled selected hidden>请输入</option>
              <option :value="item.id" v-for="(item, index) in consultationDoctors" :key="index">{{item.userName}}</option>
            </select>
          </p>
        </div>
        <mt-field v-model="ruleForm.diagnosisDate" style="ime-mode:disabled;" label="选择日期" placeholder="此项为必选项" type="datetime" @focus.native.capture="openData"></mt-field>
        <mt-datetime-picker
          ref="picker"
          type="datetime"
          v-model="pickerValue"
          @confirm="handleConfirm"
          :startDate="startDate">
        </mt-datetime-picker>
        <mt-field style="margin-bottom:15px;" label="备注" placeholder="请输入" type="text" v-model="ruleForm.remark"></mt-field>
        <div class="upload-wrapper">
          <span>知情同意书拍照上传: </span>
          <input id="file" type="file" v-show="false" ref="input" @change="fileChange($event)">
          <mt-button type="primary" size="small" @click="$refs.input.click()">点击上传</mt-button>
          <div style="margin-top:10px;">只能上传jpg/png/jpeg文件,且不超过5M</div>
          <div v-show="fileName" style="border-bottom:1px solid #ccc;padding:5px;overflow:hidden;margin-top:5px;">
            <p style="float:left;margin:0;">{{this.fileName}}</p>
            <p style="float:right;margin:0;cursor:pointer" @click="close">X</p>
          </div>
          <div class="btn-wrapper">
            <p class="download" @click="download">知情同意书模板下载</p>
            <p class="btn">
              <mt-button type="default" size="small" @click="cancel">取消</mt-button>
              &emsp;
              <mt-button type="primary" size="small" @click="handleSubmit">确定</mt-button>
            </p>
          </div>
        </div>  
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { Indicator } from 'mint-ui'
import moment from 'moment'
import { reject } from 'q';
export default {
  data() {
    return {
      title: '',
      pickerValue: '',
      startDate: '',
      isTopHospital: '',  //是否是顶级医院
      id: this.$route.query.rid,  //会诊申请id
      type: this.$route.query.type,
      topHospitalId: localStorage.getItem('HospitalID'),  //登录医院id
      applyHospitalList: [],  //会诊医院
      consultationDoctors: [],  //会诊医生
      file: null,
      fileName: '',
      ruleForm: {
        name: '',
        sex: '1',
        age: '',
        firstDiagnosis: '', //初步判断
        illnessRemark: '',  //会诊原因
        diagnosisHospital: '',  //会诊医院
        diagnosisDoctor: '',  //会诊医生
        diagnosisDate: [],  //会诊时间
        remark: ''  //备注
      }
    }
  },
  created() {
    let curDate = new Date()
    // this.startDate = new Date(curDate.getTime() - 60*60*1000); //前一天
    this.startDate = new Date()
    this.getApplyHospitalList()
    if (this.type == 'edit') {
      this.title = '编辑申请'
      this.edit()
    } else {
      this.title = '会诊申请'
    }
  },
  methods: {
    // 验证姓名是否合法
    checkInputName() {
      const nameReg1 = /^[\u4e00-\u9fa5a-z]+$/gi
      if (!nameReg1.test(this.ruleForm.name)) {
        Toast({
          message: '姓名不能为空且不能包含特殊字符!',
          position: 'top',
          duration: 1500
        });
      }
    },
    // 验证年龄是否合法
    checkInputAge() {
      const ageReg = /^\+?[1-9][0-9]*$/
      if (!ageReg.test(this.ruleForm.age) ) {
        Toast({
          message: '年龄不能为空且必须为正整数!',
          position: 'top',
          duration: 1500
        });
      }
    },
    // 验证患者病情是否为空
    checkInputDiagnosis() {
      if (this.ruleForm.firstDiagnosis == '') {
        Toast({
          message: '患者病情不能为空',
          position: 'top',
          duration: 1500
        });
      }
    },
    // 验证病情简介是否为空
    checkInputRemark() {
      if (this.ruleForm.illnessRemark == '') {
        Toast({
          message: '病情简介不能为空',
          position: 'top',
          duration: 1500
        });
      }
    },
    // 重置表单
    resetForm() {
      for (let item in this.ruleForm) {
        // console.log('formItem', this.ruleForm[item])
        if (item == 'diagnosisDate') {
          this.ruleForm[item] = null
        }
        this.ruleForm[item] = ''
        this.file = null
      }
      this.close()
    },
    // 清除文件列表的文件
    close() {
      this.fileName = ''
      this.file = null
      let input = document.getElementById("file")
      input.value = ''
    },
    //编辑初始化数据
    edit() {
      this.file = null
      this.Axios.get('/api/Remote/GetRemoteConById?id=' + this.id)
        .then(res => {
          const data = res.data
          // console.log(data)
          if (data.status == 100) {
            this.Axios.get('/api/Hospital/GetDoctorByHId?hospitalId='+ data.data.diagnosisHospital).then(res => {
              const data = res.data
              if (data.status == 100) {
                this.consultationDoctors =  data.data
              }
            })
            data.data.diagnosisDate = moment(data.data.diagnosisDate).format('YYYY-MM-DD HH:mm')
            // console.log(55555, data.data.url.split(" \\ "))
            this.fileName = data.data.url

            this.ruleForm = data.data
          }
        })
        .catch(error => {
          Toast({
            message: '网络错误,请联系管理员!',
            position: 'top',
            duration: 1500
          });
      })
    },
    fileChange(e) {
      let flag = false
      let arr = ["jpg", "png", "jpeg"]
      const imgSize = e.target.files[0].size
      if (imgSize > 500*1024*10) {
        Toast({
          message: '文件大小不能超过5M!',
          position: 'top',
          duration: 2000
        });
        return
      }
      let fileName = e.target.files[0].name
      let index = fileName.lastIndexOf(".");
      const ext = fileName.substr(index + 1);
      // alert(ext)
      for (var i=0; i<arr.length; i++) {
        if(ext == arr[i]) {
          flag = true; //一旦找到合适的，立即退出循环
          break;
        }
      }
      if (!flag) {
        Toast({
          message: '只能上传png,jgp,jpeg文件!',
          position: 'top',
          duration: 2000
        });
        return
      }
      this.file = e.target.files[0]
      this.fileName = e.target.files[0].name
    },
    // 点击取消回到会诊页面
    cancel() {
      this.$router.push({
        name: 'Consultation'
      })
    },
    // 获取所有会诊医院
    getApplyHospitalList() {
      this.Axios.get('/api/Hospital/GetSuperiorHospital?hospitalID=' + this.topHospitalId)
        .then(res => {
          let data = res.data
          if (data.status == 100) {
            // this.isShowConsultation = true
            this.applyHospitalList = data.data
            this.isTopHospital = false
          } else if (data.status == 101) {
            // console.log('没有上级医院')
            this.isTopHospital = true
            Toast({
              message: '当前登录用户没有上级医院!',
              position: 'top',
              duration: 1500
            });
            // this.isShowConsultation = false
            // this.$message({
            //   showClose: true,
            //   message: '当前登录用户没有上级医院!',
            //   type: 'error'
            // })
          }
        })
        .catch(error => {
          Toast({
            message: '网络错误,请联系管理员!',
            position: 'top',
            duration: 1500
          });
        })
    },
    // 根据会诊医院获取会诊医生
    changeHospital(id) {
      this.Axios.get('/api/Hospital/GetDoctorByHId?hospitalId=' + id)
        .then(res => {
          this.ruleForm.diagnosisDoctor = null
          let data = res.data
          if (data.status == 100) {
            // this.commonForm.diagnosisDoctor = null
            this.consultationDoctors = data.data
          } else {
            this.consultationDoctors = null
            Toast({
              message: '该医院下没有医生',
              position: 'top',
              duration: 1500
            });
          }
        })
        .catch(error => {
          Toast({
            message: '网络错误请联系管理员!',
            position: 'top',
            duration: 1500
          });
      })
    },
    openData() {
      this.$refs.picker.open()
      document.activeElement.blur()
    },
    // 选择时间
    handleConfirm() {
      this.ruleForm.diagnosisDate = this.pickerValue
      this.ruleForm.diagnosisDate = moment(this.pickerValue).format('YYYY-MM-DD HH:mm')
    },
    // 新增会诊申请
    addFile() {
      if (this.file == '' || this.file == null) {
        Toast({
          message: '必须上传知情同意书!',
          position: 'top',
          duration: 1500
        });
        return
      }

      const ageReg = /^\+?[1-9][0-9]*$/
      if (!ageReg.test(this.ruleForm.age)) {
        Toast({
          message: '年龄不能为空必须为正整数!',
          position: 'top',
          duration: 1500
        });
        return
      }

      // const nameReg = /^\S*$/
      // if (!nameReg.test(this.ruleForm.name)) {
      //   Toast({
      //     message: '姓名不能包含空格!',
      //     position: 'top',
      //     duration: 1500
      //   });
      //   return
      // }

      const nameReg1 = /^[\u4e00-\u9fa5a-z]+$/gi
      if (!nameReg1.test(this.ruleForm.name)) {
        Toast({
          message: '姓名不能为空且不能包含特殊字符!',
          position: 'top',
          duration: 1500
        });
        return
      }

      if (this.ruleForm.illnessRemark == '') {
        Toast({
          message: '病情简介不能为空',
          position: 'top',
          duration: 1500
        });
        return
      }

      if (this.ruleForm.firstDiagnosis == '') {
        Toast({
          message: '患者病情不能为空',
          position: 'top',
          duration: 1500
        });
        return
      }

      if (this.ruleForm.diagnosisDate == '') {
        Toast({
          message: '必须选择日期',
          position: 'top',
          duration: 1500
        });
        return
      }

      let fd = new FormData()
      fd.append('fileinput', this.file)
      Indicator.open("加载中...")
      this.Axios.post('/api/Remote/UploadFile', fd).then(res => {
        const data = res.data
        if (data.status === 100) {
          let formData = {
            Id: data.id, //文件id
            name: this.ruleForm.name,
            sex: this.ruleForm.sex,
            age: this.ruleForm.age,
            firstDiagnosis: this.ruleForm.firstDiagnosis, //诊断
            diagnosisDoctor: this.ruleForm.diagnosisDoctor, //会诊医生
            diagnosisHospital: this.ruleForm.diagnosisHospital, //会诊医院
            illnessRemark: this.ruleForm.illnessRemark, //病情简介
            // diagnosisDate: new Date(this.ruleForm.diagnosisDate),
            DiagnosisDate: this.ruleForm.diagnosisDate,
            remark: this.ruleForm.remark //备注
          }
          this.Axios.post('/api/Remote/AddRemoteCon', formData)
            .then(res => {
              const data = res.data
              if (data.status === 100) {
                Indicator.close()
                // this.resetForm()
                Toast({
                  message: data.message,
                  position: 'top',
                  duration: 1500
                });
                this.$router.push({
                  name: 'Consultation'
                })
              } else {
                Indicator.close()
                Toast({
                  message: data.message,
                  position: 'top',
                  duration: 1500
                })
              }
            })
            .catch(error => {
              Indicator.close()
              Toast({
                message: error,
                position: 'top',
                duration: 1500
              });
            })
        } else {
          Indicator.close()
          Toast({
            message: data.message,
            position: 'top',
            duration: 1500
          });
        }
      })
      return false
    },
    // 编辑 没有修改文件 只上传表单数据
    editData() {
      const ageReg = /^\+?[1-9][0-9]*$/
      if (!ageReg.test(this.ruleForm.age)) {
        Toast({
          message: '年龄不能为空必须为正整数!',
          position: 'top',
          duration: 1500
        });
        return
      }

      const nameReg1 = /^[\u4e00-\u9fa5a-z]+$/gi
      if (!nameReg1.test(this.ruleForm.name)) {
        Toast({
          message: '姓名不能为空且不能包含特殊字符!',
          position: 'top',
          duration: 1500
        });
        return
      }

      if (this.ruleForm.illnessRemark == '') {
        Toast({
          message: '病情简介不能为空',
          position: 'top',
          duration: 1500
        });
        return
      }

      if (this.ruleForm.firstDiagnosis == '') {
        Toast({
          message: '患者病情不能为空',
          position: 'top',
          duration: 1500
        });
        return
      }

      if (this.ruleForm.diagnosisDate == '') {
        Toast({
          message: '必须选择日期',
          position: 'top',
          duration: 1500
        });
        return
      }

      let formData = {
        name: this.ruleForm.name,
        sex: this.ruleForm.sex,
        age: this.ruleForm.age,
        firstDiagnosis: this.ruleForm.firstDiagnosis, //诊断
        diagnosisDoctor: this.ruleForm.diagnosisDoctor, //会诊医生
        diagnosisHospital: this.ruleForm.diagnosisHospital, //会诊医院
        illnessRemark: this.ruleForm.illnessRemark, //病情简介
        // diagnosisDate: new Date(this.ruleForm.diagnosisDate),
        DiagnosisDate: this.ruleForm.diagnosisDate,
        remark: this.ruleForm.remark //备注
      }
      Indicator.open("加载中...")
      this.Axios.put('/api/Remote/UpdateRemoteCon?Id=' + this.id, formData).then(res => {
        const data = res.data
        if (data.status === 100) {
          Indicator.close()
          Toast({
            message: '修改成功!',
            position: 'top',
            duration: 1500
          });
          this.$router.push({
            name: 'Consultation'
          })
        } else {
          Indicator.close()
          Toast({
            message: '修改失败!',
            position: 'top',
            duration: 1500
          });
        }
      }).catch(error => {
        Indicator.close()
        console.log(error)
      })
    },
    // 编辑 修改了文件
    editDataFile() {
      if (this.file == '' || this.file == null) {
        Toast({
          message: '必须上传知情同意书!',
          position: 'top',
          duration: 1500
        });
        return
      }

      const ageReg = /^\+?[1-9][0-9]*$/
      if (!ageReg.test(this.ruleForm.age)) {
        Toast({
          message: '年龄不能为空必须为正整数!',
          position: 'top',
          duration: 1500
        });
        return
      }

      // const nameReg = /^\S*$/
      // if (!nameReg.test(this.ruleForm.name)) {
      //   Toast({
      //     message: '姓名不能包含空格!',
      //     position: 'top',
      //     duration: 1500
      //   });
      //   return
      // }

      const nameReg1 = /^[\u4e00-\u9fa5a-z]+$/gi
      if (!nameReg1.test(this.ruleForm.name)) {
        Toast({
          message: '姓名不能为空且不能包含特殊字符!',
          position: 'top',
          duration: 1500
        });
        return
      }

      if (this.ruleForm.illnessRemark == '') {
        Toast({
          message: '病情简介不能为空',
          position: 'top',
          duration: 1500
        });
        return
      }

      if (this.ruleForm.firstDiagnosis == '') {
        Toast({
          message: '患者病情不能为空',
          position: 'top',
          duration: 1500
        });
        return
      }

      if (this.ruleForm.diagnosisDate == '') {
        Toast({
          message: '必须选择日期',
          position: 'top',
          duration: 1500
        });
        return
      }

      let fd = new FormData()
      fd.append('file', this.file)
      Indicator.open("加载中...")
      this.Axios.post('/api/Remote/UploadFileAsync', fd).then(res => {
        const data = res.data
        if (data.status === 100) {
          let formData = {
            newid: data.id, //文件id
            name: this.ruleForm.name,
            sex: this.ruleForm.sex,
            age: this.ruleForm.age,
            firstDiagnosis: this.ruleForm.firstDiagnosis, //诊断
            diagnosisDoctor: this.ruleForm.diagnosisDoctor, //会诊医生
            diagnosisHospital: this.ruleForm.diagnosisHospital, //会诊医院
            illnessRemark: this.ruleForm.illnessRemark, //病情简介
            // diagnosisDate: new Date(this.ruleForm.diagnosisDate),
            DiagnosisDate: this.ruleForm.diagnosisDate,
            remark: this.ruleForm.remark //备注
          }
          this.Axios.put('/api/Remote/UpdateRemoteCon?id=' + this.id, formData)
            .then(res => {
              const data = res.data
              if (data.status === 100) {
                this.resetForm()
                Indicator.close()
                Toast({
                  message: '修改成功!',
                  position: 'top',
                  duration: 1500
                });
                this.$router.push({
                  name: 'Consultation'
                })
              } else {
                Toast({
                  message: data.message,
                  position: 'top',
                  duration: 1500
                })
              }
            })
          .catch(error => {
            Indicator.close()
            console.log(error)
          })
        } else {
          Indicator.close()
          Toast({
            message: '修改失败!',
            position: 'top',
            duration: 1500
          });
        }
      })
      return false
    },
    handleSubmit() {
      if (this.type == 'add') {
        this.addFile()
      }
      if (this.type == 'edit') {
        if (this.file == null) {
          this.editData()
        }
        if (this.file != null) {
          // console.log('editdatafile')
          this.editDataFile()
        }
      }
    },

    download() {
      // agreementFile/知情同意书模板.pdf
      window.open('https://m.teleicu.cn/agreementFile/%E7%9F%A5%E6%83%85%E5%90%8C%E6%84%8F%E4%B9%A6%E6%A8%A1%E6%9D%BF.pdf')
    },
  }
}
</script>

<style lang="less">
.addFile {
  height: 99%;
  overflow: auto;
  .addApply {
    height: 100%;
    .title {
      font-size: 14px;
      height: 3%;
      padding: 2% 2%;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      background: #f5f5f9;
    }
    .formContent {
      .radioGroup {
        height: 48px;
        line-height: 48px;
        padding: 0 10px;
        // border-top: 1px dashed #eeeeee;
        // border-bottom: 1px dashed #eee;
        span {
          width: 105px;
          display: block;
          float: left;
        }
        .radio-inline {
          float: left;
          margin-right: 10px;
          input[type="radio"] + label::before {
            content: "\a0";
            display: inline-block;
            vertical-align: middle;
            width: 10px;
            height: 10px;
            margin-right: 5px;
            border-radius: 50%;
            text-indent: .15em;
            margin-bottom: 4px;
            border: 1px solid #CCCCCC;
            padding: 2px;
          }
          input[type="radio"] {
            position: absolute;
            clip: rect(0, 0, 0, 0);
          }
          input[type="radio"]:checked + label::before {
            background-color: #4A90E2;
            background-clip: content-box;
            padding: 2px;
          }
        }
      }
      .text-area {
        padding-left: 10px;
        padding-right: 5px;
        margin-top: 16px;
        &::after {
          content: "";
          display: block;
          width: 0;
          height: 0;
          clear: both;
        }
        textarea {
          outline: none;
          width: 63%;
          border: 1px solid #ccc;
          float: left;
        }
        label {
          display: block;
          width: 105px;
          float: left;
          top: 0;
        }
      }
      .select-wrapper {
        padding-left: 2%;
        label {
          display: inline-block;
          width: 105px;
        }
        .hzHospital{
          background: rgba(0,0,0,0);
          width: 55%;
          height: 32px;
          font-family: "微软雅黑";
          font-size: 14px;
          color: #000;
          border: 1px #eee solid;
          border-radius: 5px;
          // margin-left: 2%;
          outline: none;
          &:focus{
            border: 1px #ddd solid;
            box-shadow: 0 0 15px 1px #DDDDDD;
          }
          option{
            color: 666;
            background: white;
            line-height: 20px;
          }
        }
      }
      .upload-wrapper {
        padding-left: 2%;
        font-size: 14px;
        .btn-wrapper {
          display: flex;
          overflow: hidden;
          padding-right: 2%;
          .download {
            background: url('../../assets/u313.png') no-repeat;
            text-indent: 18px;
            margin-top: 6%;
            width: 170px;
            // font-size: 12px;
          }
          .btn {
            flex: 1;
            text-align: right;
          }
        }
      }
    }
  }
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder, select {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-moz-placeholder, textarea::-moz-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-ms-input-placeholder, textarea::-ms-input-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
}
</style>
